import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getTermValue } from '../../../packages/JsonQuery';

export const selectTravelType = createSelector(selectJsonQuery, jsonQuery => getTermValue('only_foot')(jsonQuery));
